var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-830.703 -422)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(830.703 422)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M124.663,1.063a2.778,2.778,0,0,0-3.905,0L109.81,11.917a.607.607,0,0,0-.157.268l-1.44,5.153a.6.6,0,0,0,.157.593.618.618,0,0,0,.6.156l5.2-1.428a.614.614,0,0,0,.27-.156L125.383,5.649a2.724,2.724,0,0,0,0-3.872Zm-13.516,11.25,8.96-8.884L123,6.294l-8.96,8.884Zm-.577,1.148,2.309,2.289-3.193.877Zm13.945-8.673-.651.645-2.89-2.865.651-.645a1.543,1.543,0,0,1,2.169,0l.72.714A1.514,1.514,0,0,1,124.515,4.788Zm0,0",
    transform: "translate(-108.19 -0.261)"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#858585",
    width: 11.309,
    height: 1.414,
    rx: 0.707,
    transform: "translate(837.374 438.586)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.eeaa88bf01794901fa8396c1928de99a.svg";
export { ForwardRef as ReactComponent };